import React, { useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Steps } from 'antd';

import { ERequestStatus } from 'v2/interfaces/shopping';
import type { IRefundRequest, ShoppingDelivery } from 'v2/interfaces/shopping';
import { dateService } from 'v2/services/date';
import { refundRequestFactory } from 'v2/services/shopping/refundRequest';

import { Icon } from '@eduzz/ui-antd-theme';

const RefundStatus = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const [refundRequest] = useObservable<IRefundRequest>(
    () => refundRequestFactory.buyerFindRefundByInvoiceId(delivery.invoice_id),
    []
  );
  const [refundMessage, setRefundMessage] = useState<boolean>(false);
  const [approvedMessage, setApproveMessage] = useState<boolean>(false);
  const [reprovedMessage, setReprovedMessage] = useState<boolean>(false);

  useEffect(() => {
    setRefundMessage(refundRequest?.status === ERequestStatus.PENDING);
    setApproveMessage(refundRequest?.status === ERequestStatus.APPROVED);
    setReprovedMessage(refundRequest?.status === ERequestStatus.REPROVED);
  }, [refundRequest]);

  const isThereAMessage = refundMessage || approvedMessage || reprovedMessage;

  if (!isThereAMessage) return null;

  const stepsItems: Array<{ title: string; icon: React.ReactNode }> = [];

  if (refundMessage || approvedMessage || reprovedMessage) {
    stepsItems.push({
      title: `Seu reembolso foi solicitado e aguarda aprovação do produtor - ${dateService.dateToString(
        new Date(refundRequest?.requested_at),
        'dd/MM/yyyy HH:mm'
      )}`,
      icon: <Icon.CircleCheck size={24} />
    });
  }

  if (approvedMessage) {
    stepsItems.push({
      title: 'Seu reembolso foi aprovado pelo produtor.',
      icon: <Icon.CircleCheck size={24} className='text-(--uizz-antd-color-success)' />
    });
  }

  if (reprovedMessage) {
    stepsItems.push({
      title: `Seu reembolso foi reprovado pelo produtor. Motivo: ${refundRequest?.justification}`,
      icon: <Icon.CircleX size={24} className='text-(--uizz-antd-color-error)' />
    });
  }

  return (
    <div className='mt-4'>
      <Steps direction='vertical' current={stepsItems.length} items={stepsItems} />
    </div>
  );
};

export default RefundStatus;
